import { css } from '@/styled-system/css';

export const hdpForm = css({
  position: 'relative',
  clear: 'both',
  marginTop: '0',
  marginRight: 'auto',
  marginBottom: '0',
  marginLeft: 'auto',
  maxWidth: '635px',
});
